import { MessageHtml as MessageHtmlView, type MessageHtmlProps as MessageHtmlViewProps } from "@qw/ui";
import type { FC } from "react";
import shadowStyles from "./shadow-dom.css?inline";

export type MessageHtmlProps = Omit<MessageHtmlViewProps, "shadowStyles">;

export const MessageHtml: FC<MessageHtmlProps> = (props) => <MessageHtmlView {...props} shadowStyles={shadowStyles} />;
